// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useEffect } from 'react';
import { useAdjustmentsContextActions } from '../../../../controllers/adjustments-context';
import { useViewType } from '../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../controllers/issue-adjustments/main';
import { getAnalytics } from '../../../../controllers/view-configuration';
export var useContextCleanup = function useContextCleanup(payload) {
  var executionContextKey = payload.executionContextKey,
    numberOfSupportedFields = payload.numberOfSupportedFields,
    resetFormFieldsCounter = payload.resetFormFieldsCounter;
  var _useIssueAdjustmentsA = useIssueAdjustmentsActions(),
    resetAllFields = _useIssueAdjustmentsA.resetAllFields,
    triggerFieldInitialization = _useIssueAdjustmentsA.triggerFieldInitialization,
    setNumberOfSupportedFields = _useIssueAdjustmentsA.setNumberOfSupportedFields;
  var _useAdjustmentsContex = useAdjustmentsContextActions(),
    resetAdjustmentContext = _useAdjustmentsContex.resetAdjustmentContext;
  var viewType = useViewType();
  useEffect(function () {
    if (numberOfSupportedFields !== undefined) {
      setNumberOfSupportedFields(numberOfSupportedFields);
    }
    return function () {
      return setNumberOfSupportedFields(0);
    };
  }, [numberOfSupportedFields, setNumberOfSupportedFields]);
  useEffect(function () {
    triggerFieldInitialization();
    return resetAllFields;
    // Whenever the executionContextKey is changed, or the resetFormFieldsCounter
    // is incremented ("create another issue" GIC) we want to reset any data in our store.
    // For "create another issue" `resetFormFieldsCounter` we trigger re-initialization of field data.
  }, [executionContextKey, resetFormFieldsCounter, resetAllFields, triggerFieldInitialization]);
  useEffect(function () {
    return function () {
      resetAdjustmentContext();
      getAnalytics(viewType).cancelTTI();
    };
  },
  // When executionContextKey is changed we reset the AdjustmentsContext because
  // other executionContextKey may not be configured to run UI modifications
  [executionContextKey, resetAdjustmentContext, viewType]);
};